import { IonContent } from '@ionic/react';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { webCampaign } from '@/modules/webCampaign';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { AI_DATA } from '@/pages/Onboarding/constants';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OnboardingParamsTool } from '@/pages/Onboarding/utils/paramsTool';
import { canLogEvents } from '@/utils/canLogEvents';
import { preloadImage } from '@/utils/preloadImage';

import { OnboardingChatExampleStyles } from './ChatExample.styles';

export const ScreenChatExample: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'ChatExample',
      });
    }

    preloadImage(
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/loneliness/loneliness_graph.png',
    );
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = (): void => {
    wizard.nextStep();
    OnboardingParamsTool.setParam('step', 'loneliness');
  };

  return (
    <OnboardingChatExampleStyles>
      <OnboardingNavigation />

      <IonContent>
        <OnboardingTitle>Complete chat experience</OnboardingTitle>
        <OnboardingSubtitle>
          Get text, photo, and video replies.
          <br />
          Anytime you want.
        </OnboardingSubtitle>
        <div className="img-container">
          <img src={AI_DATA[webCampaign.aiType].chat.imageSrc} alt="chat" />
        </div>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </OnboardingChatExampleStyles>
  );
};
